// CreateSixService.ts
import type { CreateSixModalInformation, UpdateSixPayload } from "@/types/create-six.types";
import type { UpdateSixResponseDTO } from "@/types/SixDetailDTOs";

export interface SixCreated {
  sixId: string;
  name: string;
}

export interface ValidName {
  valid: true
}

export abstract class CreateSixService {
  /**
   * Checks whether a SIX name is already in use.
   * Should reject with an error that carries HTTP‐status `409`
   * (or a custom DuplicateNameError) if a duplicate is found.
   */
  abstract validateName(name: string): Promise<ValidName>;

  /**
   * Creates the SIX in one call and returns its id & name.
   * Implementations should reject with validation errors
   * the same way `validateName` does, so the wizard can show them.
   */
  abstract createSix(payload: {
    name: string;
    description: string;
    ownerIds: string[];               // always at least one
    internalParticipantIds: string[]; // existing org users
    externalParticipantIds: string[]; // existing externals
  }): Promise<SixCreated>;

  /**
   * Updates an existing SIX via PATCH.
   * Returns an async command acknowledgment (HTTP 202).
   */
  abstract updateSix(sixId: string, payload: UpdateSixPayload): Promise<UpdateSixResponseDTO>;

  /** Full list of org users for the “Internal participants” picker. */
  abstract getCreateSixModalInformation(): Promise<CreateSixModalInformation>;

}
